import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import { AppConstants } from 'src/app/_apps/app.constants';
import * as fromRootMiscActions from 'src/app/_apps/root/store/misc/misc.actions';
import { Skin } from 'src/app/_common/services';
import { SelectOption } from 'src/app/_ui/components/form/common';

@Component({
    selector: 'aa-switch-theme',
    templateUrl: './switch-theme.component.html',
    styleUrls: [
        './switch-theme.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchThemeComponent implements OnInit
{
    // Single source of truth: the very same list as the "My profile > Parameters"
    // skin dropdown, so the footer can never offer a theme the profile hides.
    public readonly themes: SelectOption[] = AppConstants.frontThemes;

    constructor(
        private store: Store<IAuroraState>
    ) { }

    ngOnInit ()
    {
    }

    public onSwitchTheme (theme: SelectOption)
    {
        this.onSwitchSkin(theme.value.toString().replace('theme-', '') as Skin);
    }

    public onSwitchSkin (skin: Skin)
    {
        this.store.dispatch(fromRootMiscActions.RootMiscSkinSwitched({ skin }));
    }
}
